import { Datagrid, FunctionField, List, ReferenceField, ReferenceInput, Resource, SelectInput } from "react-admin";
import { MoneyField } from "../fields/MoneyField";
import { restrictAccessToDrivingSchoolIds } from "../backoffice.access_control";
import { ReferenceDrivingSchoolField } from "../fields/ReferenceDrivingSchoolField";
import { BackofficeListTitle } from "../misc/BackofficeListTitle";
import { Student } from "../providers/studentsProvider";
import { DateTime } from "luxon";

export const graduatedInvoiceCustomersResource = (
  <Resource
    key="graduatedInvoiceCustomers"
    name="graduatedInvoiceCustomers"
    list={GraduatedInvoiceCustomersList}
    options={{ label: "Fertige Schüler mit negativem Saldo" }}
  />
);

function GraduatedInvoiceCustomersList() {
  return (
    <List
      title={<BackofficeListTitle />}
      filter={
        restrictAccessToDrivingSchoolIds?.length === 1
          ? { drivingSchoolId: restrictAccessToDrivingSchoolIds[0] }
          : undefined
      }
      filters={
        restrictAccessToDrivingSchoolIds?.length === 1
          ? []
          : [
              <ReferenceInput
                alwaysOn
                source="drivingSchoolId"
                reference="drivingSchools"
                key="drivingSchoolId"
                page={1}
                perPage={999}
                sort={{ field: "name", order: "ASC" }}
              >
                <SelectInput label="Fahrschule" />
              </ReferenceInput>,
            ]
      }
      exporter={false}
    >
      <Datagrid rowClick={(studentId) => `/students/${studentId}/invoices`} bulkActionButtons={false}>
        <ReferenceField label="Fahrschüler" reference="students" source="id" />
        <ReferenceDrivingSchoolField label="Fahrschule" source="drivingSchoolId" link />
        <MoneyField label="Saldo" source="balance" redForNegativeValues />
        <FunctionField
          label="Datum der bestandenen praktischen Prüfung"
          render={_renderNewestPassedPracticalExamDate}
        />
      </Datagrid>
    </List>
  );
}

function _renderNewestPassedPracticalExamDate(student: Student): string {
  const passedPracticalExamsDates: DateTime[] = [];
  for (const bookedTraining of student.bookedTrainings) {
    for (const practicalExam of Object.values(bookedTraining.kpis?.practicalExams ?? {})) {
      if (practicalExam.result === "passed") {
        passedPracticalExamsDates.push(practicalExam.date);
      }
    }
  }
  const date = passedPracticalExamsDates.sort((a, b) => a.toMillis() - b.toMillis()).at(-1);
  return date ? date.toFormat("dd.MM.yyyy") : "";
}
